import React from "react";

import { useTranslation } from "react-i18next";
import ErrorPlaceholder from "../ErrorPlaceholder";

const Page404 = () => {
  const { t } = useTranslation();

  return (
    <ErrorPlaceholder title1={t("NOT")} title2={t("FOUND")} desc={t("The page you are looking for does not exist")} />
  );
};

export default React.memo(Page404);
